import { useCallback } from "react";
import { useStateAwareNavigate } from "./useStateAwareNavigate";

export function useGoToTemplate() {
    const navigate = useStateAwareNavigate();

    return useCallback(
        (templateId: string) => {
            const params = new URLSearchParams({ templateId });
            navigate(`/templates/services?${params.toString()}`);
        },
        [navigate],
    );
}
